module.exports = __webpack_public_path__ + "img/shed-logo-640.c62074f5.jpg";